import { z } from 'zod';
// §3.1b Phase 1 (s232) — provenance shared between every extractable
// brain row (team, products, testimonials, voice samples, motifs,
// future testimonials/voice_anti_examples/etc.). Lives in its own
// file so other schema modules (brand-design-system.ts, future
// brand-research.ts, etc.) can import it without round-tripping back
// through brand-brain.ts and tripping ESM cycles.
export const brainRowProvenanceMethodSchema = z.enum([
    /** Card-mode HTML extraction — one image with its tight DOM
     *  subtree of text (s231a). */
    'html-card',
    /** Flat page text + identity context (s221 products path). */
    'page-text',
    /** Vision pass against a rendered page screenshot. */
    'vision-page',
    /** Vision pass against a cropped element screenshot (Phase 4 verifier). */
    'vision-screenshot',
    /** Inferred from Meta history learn pass. */
    'ig-history',
    /** Founder interview during onboarding (future). */
    'founder-interview',
    /** Founder typed from scratch in the brand hub. */
    'founder-manual',
    /** Promoted by the nightly critic agent (Phase 6). */
    'critic-verified',
]);
export const brainRowProvenanceSchema = z.object({
    method: brainRowProvenanceMethodSchema,
    /** The URL the extractor read (page URL, asset URL, etc.). */
    evidenceUrl: z.string().url().optional(),
    /** Verbatim snippet from the source, ≤ 280 chars. Persisted so
     *  support / debugging can trace mismatches without re-running the
     *  pipeline. Not surfaced in creative prompts. */
    evidenceSnippet: z.string().max(280).optional(),
    extractedAt: z.string().datetime(),
    /** When a tier-2 verifier (Phase 4) or the critic (Phase 6) signed
     *  off, the verifying agent + its own confidence land here. */
    verifiedBy: z
        .object({
        agent: z.string().max(80),
        agentConfidence: z.number().min(0).max(1),
    })
        .optional(),
});
//# sourceMappingURL=brain-row-provenance.js.map